import { Component, Input, OnInit } from '@angular/core';
import { ProjectsOverviewService } from '../../../../data-services/projects-overview.service';
import { OrderOrganizationReference } from '../../../../shared/dto/projects/order-organization-reference';

@Component({
  selector: 'townip-vendor-reference-number-display',
  templateUrl: './vendor-reference-number-display.component.html',
  styleUrls: ['./vendor-reference-number-display.component.scss']
})
export class VendorReferenceNumberDisplayComponent implements OnInit {

  @Input()
  public orderId: any;

  @Input()
  public vendorCountryRefNumbers: OrderOrganizationReference[];

  constructor(private projectOverviewService: ProjectsOverviewService) { }

  public ngOnInit(): void { }

  public async getVendorCountryFilingReferenceNumbers(): Promise<void> {
    if (this.vendorCountryRefNumbers || !this.orderId) {
      return;
    }

    this.vendorCountryRefNumbers = await this.projectOverviewService
      .getVendorCountryFilingReferenceNumbers(this.orderId)
      .toPromise();
  }

}
